import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { AdminLayout } from './layouts/admin-layout/admin-layout';

export const routes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

    // Routes of Auth with layout
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('./pages/auth/auth.routes').then(itemm => itemm.AuthRoutes),
    },

    // Routes of Admin with layout & guard
    {
        path: '',
        component: AdminLayout,
        canActivate: [],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

            {
                path: 'app_service',
                loadChildren: () => import('./pages/app_service/routes').then(item => item.ROUTES)
            },
            {
                path: 'app_settings',
                loadChildren: () => import('./pages/app_settings/routes').then(item => item.ROUTES)
            },
            {
                path: 'app_logger',
                loadChildren: () => import('./pages/app_logger/routes').then(item => item.ROUTES)
            },
            {
                path: 'app_control_geocoder',
                loadChildren: () => import('./pages/app_control_geocoder/routes').then(item => item.ROUTES)
            },
            {
                path: 'change_log',
                loadChildren: () => import('./pages/change_log/routes').then(item => item.ROUTES)
            },
            {
                path: 'faq',
                loadChildren: () => import('./pages/faq/routes').then(item => item.ROUTES)
            },

            {
                path: 'user',
                loadChildren: () => import('./pages/user/routes').then(item => item.ROUTES)
            },
            {
                path: 'permission_module',
                loadChildren: () => import('./pages/permission_module/routes').then(item => item.ROUTES)
            },
            {
                path: 'permission',
                loadChildren: () => import('./pages/permission/routes').then(item => item.ROUTES)
            },
            {
                path: 'permission_per_user',
                loadChildren: () => import('./pages/permission_per_user/routes').then(item => item.ROUTES)
            },

            {
                path: 'catalog_country',
                loadChildren: () => import('./pages/catalog_country/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_state',
                loadChildren: () => import('./pages/catalog_state/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_city',
                loadChildren: () => import('./pages/catalog_city/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_job_position',
                loadChildren: () => import('./pages/catalog_job_position/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_format_date',
                loadChildren: () => import('./pages/catalog_format_date/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_format_number',
                loadChildren: () => import('./pages/catalog_format_number/routes').then(item => item.ROUTES)
            },
            {
                path: 'catalog_language',
                loadChildren: () => import('./pages/catalog_language/routes').then(item => item.ROUTES)
            },

            {
                path: 'management',
                loadChildren: () => import('./pages/management/routes').then(item => item.ROUTES)
            },
            {
                path: 'management_region',
                loadChildren: () => import('./pages/management_region/routes').then(item => item.ROUTES)
            },
            {
                path: 'management_division',
                loadChildren: () => import('./pages/management_division/routes').then(item => item.ROUTES)
            },
            {
                path: 'management_per_management_region',
                loadChildren: () => import('./pages/management_per_management_region/routes').then(item => item.ROUTES)
            },
            {
                path: 'management_campus',
                loadChildren: () => import('./pages/management_campus/routes').then(item => item.ROUTES)
            },
            {
                path: 'adviser_per_management',
                loadChildren: () => import('./pages/adviser_per_management/routes').then(item => item.ROUTES)
            },
            {
                path: 'retirement_profile',
                loadChildren: () => import('./pages/retirement_profile/routes').then(item => item.ROUTES)
            },
            {
                path: 'retirement_profile_per_user',
                loadChildren: () => import('./pages/retirement_profile_per_user/routes').then(item => item.ROUTES)
            },
            {
                path: 'retirement_profile_per_user_history',
                loadChildren: () => import('./pages/retirement_profile_per_user_history/routes').then(item => item.ROUTES)
            },
            {
                path: 'retirement_profile_tracking',
                loadChildren: () => import('./pages/retirement_profile_tracking/routes').then(item => item.ROUTES)
            },
            {
                path: 'retirement_profile_blacklist',
                loadChildren: () => import('./pages/retirement_profile_blacklist/routes').then(item => item.ROUTES)
            },
            {
                path: 'request_retirement_profile_per_user',
                loadChildren: () => import('./pages/request_retirement_profile_per_user/routes').then(item => item.ROUTES)
            },
            {
                path: 'request_retirement_profile',
                loadChildren: () => import('./pages/request_retirement_profile/routes').then(item => item.ROUTES)
            },
            {
                path: 'ticket_support_type',
                loadChildren: () => import('./pages/ticket_support_type/routes').then(item => item.ROUTES)
            },
            {
                path: 'ticket_support',
                loadChildren: () => import('./pages/ticket_support/routes').then(item => item.ROUTES)
            },
            {
                path: 'ticket_support_tracking',
                loadChildren: () => import('./pages/ticket_support_tracking/routes').then(item => item.ROUTES)
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./pages/admin/dashboard/dashboard.page').then(item => item.DashboardPage),
            },
            {
                path: 'notification',
                loadChildren: () => import('./pages/notification/routes').then(item => item.ROUTES)
            },
            {
                path: 'whatsapper',
                loadChildren: () => import('./pages/whatsapper/routes').then(item => item.ROUTES)
            },
            {
                path: 'utilities',
                loadChildren: () => import('./pages/utilities/routes').then(item => item.ROUTES)
            },
        ],
    },

    // 404 → NotFoundPage
    {
        path: '**',
        loadComponent: () => import('./pages/not_found/not_found.page').then(item => item.NotFoundPage),
    },
];